import { render, staticRenderFns } from "./ImageMagnifying.vue?vue&type=template&id=54d54dba&scoped=true"
import script from "./ImageMagnifying.vue?vue&type=script&lang=js"
export * from "./ImageMagnifying.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d54dba",
  null
  
)

export default component.exports